export interface LocationIdentity {
  pickupLocationId: number | null;
  pickupLocationName: string | null;
}

export interface LocationSortableItem extends LocationIdentity {
  pickupLocationColorCode?: string | null;
  thaaliNumber: string | null;
  memberName: string;
}

export function getLocationGroupKey(locationId: number | null): string {
  return locationId != null ? `location-${locationId}` : 'unassigned';
}

export function compareLocationIdentity(a: LocationIdentity, b: LocationIdentity) {
  const locationNameCompare = (a.pickupLocationName || 'ZZZ').localeCompare(
    b.pickupLocationName || 'ZZZ'
  );
  if (locationNameCompare !== 0) return locationNameCompare;

  return getLocationGroupKey(a.pickupLocationId).localeCompare(
    getLocationGroupKey(b.pickupLocationId)
  );
}

export function compareLocationSorted(a: LocationSortableItem, b: LocationSortableItem) {
  const locationCompare = compareLocationIdentity(a, b);
  if (locationCompare !== 0) return locationCompare;

  const thaaliCompare = (a.thaaliNumber || '').localeCompare(b.thaaliNumber || '');
  if (thaaliCompare !== 0) return thaaliCompare;

  return a.memberName.localeCompare(b.memberName);
}

export function createFirstOfLocationSet<T extends Pick<LocationIdentity, 'pickupLocationId'>>(
  data: T[]
) {
  const firstOfLocationSet = new Set<number>();
  let previousLocationKey: string | null = null;

  data.forEach((item, index) => {
    const locationKey = getLocationGroupKey(item.pickupLocationId);
    if (locationKey !== previousLocationKey) {
      firstOfLocationSet.add(index);
      previousLocationKey = locationKey;
    }
  });

  return firstOfLocationSet;
}

export function groupByLocation<T extends LocationSortableItem>(data: T[]): Array<{
  key: string;
  name: string;
  colorCode: string | null;
  items: T[];
}> {
  const groups = new Map<
    string,
    { key: string; name: string; colorCode: string | null; items: T[] }
  >();

  for (const item of data) {
    const key = getLocationGroupKey(item.pickupLocationId);
    if (!groups.has(key)) {
      groups.set(key, {
        key,
        name: item.pickupLocationName || 'Unassigned',
        colorCode: item.pickupLocationColorCode || null,
        items: [],
      });
    }

    groups.get(key)!.items.push(item);
  }

  return Array.from(groups.values());
}
